<style scoped>
.fw-lighter {
  font-weight: lighter !important;
}
a {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #2E78C2;
  margin-top: 10px;
}
</style>

<template>
  <b-container v-if="originator">
    <h4 class="mt-3 text-uppercase">Your Anchor Team</h4>
    <b-row class="mt-4">
      <b-col>
          <p class="font-weight-bold">{{originator.name}}</p>
          <p class="font-italic font-weight-light fw-lighter">Account Executive</p>
      </b-col>
      <b-col>
        <p><a v-bind:href="'mailto:' + originator.email">{{originator.email}}</a></p>
        <p><a v-bind:href="'tel:' + originator.phone">{{originator.phone}}</a></p>
      </b-col>
    </b-row>
  </b-container>

  <b-container v-else>
    <h4 class="mt-3 text-uppercase">Contact</h4>
    <b-row class="mt-3">
      <b-col lg="4" md="6" xl="4" sm="5">
        <p>Main Office</p>
      </b-col>
      <b-col>
          <p>
            <a href="tel:(888) 719-5299">(888) 719-5299</a> <br/>
            <a href="mailto:info@anchorloans.com">
              info@anchorloans.com
            </a>
          </p>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col lg="4" md="6" xl="4" sm="5">
        <p>Loan Servicing</p>
      </b-col>
      <b-col>
          <p>
            Processing <br/>
            <a href="mailto:proteam@anchorloans.com">
              proteam@anchorloans.com
            </a>
          </p>
          <p>
            Payments <br/>
            <a href="mailto:payments@anchorloans.com">
              payments@anchorloans.com
            </a>
          </p>
          <p>
            Payoffs <br/>
            <a href="mailto:demand@anchorloans.com">
              demand@anchorloans.com
            </a>
          </p>
          <p>
            Extensions <br/>
            <a href="mailto:extensions@anchorloans.com">
              extensions@anchorloans.com
            </a>
          </p>
          <p>
            Draws <br/>
            <a href="mailto:draws@anchorloans.com">
              draws@anchorloans.com
            </a>
          </p>
      </b-col>
    </b-row>


  </b-container>
</template>

<script>
import helper from '@/libs/helper';

import NotificationsButton from './notifications/NotificationsButton';

export default {
  components: {
    NotificationsButton,
  },
  computed: {
    originator() {
      return this.$store.getters.accountExecutive;
    },
    user() {
      return this.$store.getters.user;
    },
    profile() {
      return this.$store.getters.profile;
    },
    contactMethod() {
      if (this.profile && this.profile.contact) {
        const contact = this.profile.contact;
        switch (contact.contactMethod) {
          case 'phone': {
            const phone = contact.homeNumber || contact.businessNumber;
            return phone ? helper.phoneMask(phone) : contact.email;
          }
          case 'fax':
            return contact.fax || contact.email;
          default:
            return contact.email;
        }
      }

      return this.user.email;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/profile/Profile.vue